import * as React from "react";
import "@/stylesheets/components/error_msg.scss";

interface IErrorMsg {
  msg?: React.ReactElement | string;
  icon?: string;
}

const Errormsg: React.FC<any> = (props: IErrorMsg) => {
  return (
    <>
      <div className="error-msg">
        <div className="error-msg-wrapper">
          <div>
            <span
              className={`${
                props?.icon ? props?.icon : "edel-icon-error-msg-icon"
              } erroricon`}
            ></span>
          </div>
          {props.msg ? (
            <div className="error-msg-text">{props.msg}</div>
          ) : (
            <div className="error-msg-text">Something went wrong</div>
          )}
        </div>
      </div>
    </>
  );
};

export default Errormsg;
